// extracted by mini-css-extract-plugin
export default {"wrapperButtonStep":"button-submit-step_wrapperButtonStep__cCGei","gray":"button-submit-step_gray__r548a"};